module.exports = __webpack_public_path__ + "static/triathon-0d07c3907ae2b21258d9c4f5e83cece4.pdf";